import gql from 'graphql-tag'

export const GET_FUN_FACT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getFunFactPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        value
      }
    }
  }
`

export const GET_FUN_FACT_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getFunFact (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      value
    }
  }
`

export const GET_FUN_FACT_IMAGES_QUERY = gql`
  query {
    getFunFactImages {
      backgroundImage
    }
  }
`
